import {styled} from "@mui/material/styles";
import {Box, Grid, Typography} from "@mui/material";

export const AssetBoxContainer = styled(Grid)({
    textAlign: 'center',
    cursor: 'pointer',
    padding: '8px',
});

export const AssetBoxWrapper = styled(Box)(({theme}) => ({
    backgroundColor: '#FFFFFF',
    aspectRatio: 1,
    position: 'relative',
    borderRadius: '16px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
}));

export const AssetLabel = styled(Typography)({
    marginTop: '8px',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#FFFFFF',
    fontSize: '14px',
});

export const UsedByBadge = styled(Box)({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 6px 4px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '3px',
    background: 'linear-gradient(0deg, rgba(0,0,0,0.6), transparent)',
    pointerEvents: 'none',
});

export const UsedByChip = styled(Box)({
    fontSize: '10px',
    lineHeight: 1,
    padding: '2px 6px',
    borderRadius: '8px',
    backgroundColor: '#ed6c02',
    color: '#fff',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
});